import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import {
  store
} from './store.js'
import router from './router'
import VueCookies from 'vue-cookies'
import 'chartist/dist/chartist.min.css'
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueSocialSharing from 'vue-social-sharing';


const fb = require('./firebaseConfig.js')

Vue.use(VueSocialSharing);
Vue.use(require('vue-chartist'))
Vue.use(DashboardPlugin);

Vue.use(VueCookies)
Vue.use(require('vue-moment'));

// import YQuestionnaires from '@/components/YQuestionnaires'
// import YQuesionDetail from '@/components/YQuesionDetail'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
Vue.config.productionTip = false


Vue.$cookies.config('7d')
Vue.config.productionTip = false

import myfunction from "@/components/global/myfunction.js";

// new Vue({
//   vuetify,
//   router,
//   store,
//   render: h => h(App),
//   mixins: [myfunction],
//   created(){
//     fb.auth.onAuthStateChanged(async user => {
//       console.log("reloading", user)
//       if (user != null && user.email != null) {
//         await this.xreadUserData(user,false)
//       }
//     }) please TEST
//   }
// }).$mount('#app')

fb.auth.onAuthStateChanged(async user => {
  if (user) {
    store.set("currentUser", user)
    var doc = await fb.db
      .collectionGroup("teachers")
      .where("email", "==", user.email)
      .limit(1)
      .get();
    if (doc.empty) {
      doc = await fb.db
        .collectionGroup("students")
        .where("email", "==", user.email)
        .limit(1)
        .get();
    }
    if (!doc.empty) {
      var userObj = doc.docs[0];
      if (userObj.exists) {
        let userData = userObj.data();
        userData.id = userObj.id;
        userData.ref = userObj.ref;

        // fb.dbDSStorage.collection("testtest").get().then((docs)=>{
        //   console.log(docs)
        // }) TODO

        if (userData.ref.parent.parent) {

          userData.ppschool = userData.ref.parent.parent.path
          // userData.ppschool = "schools/YodtLTjL7GNxY9NBjWco" 
          //userData.ppschool ="schools/QkJ6bvs865mbXINzHhKB"
          //DEBUG
          //userData.ppschool = "schools/nJ0ML9ltkfYarYKzKgI7" //zavkhan numrog
          // userData.ppschool = "schools/wXaBdoO4uNHp5HYUJbpK" 
          // userData.ppschool = "schools/wXaBdoO4uNHp5HYUJbpK"

          await fb.db.doc(userData.ppschool).get().then((doc) => {
            userData.school = doc.data()
            userData.school.id = doc.id
            userData.school.ref = doc.ref
          })

        } else {
          if (store.state.selectedSchoolRef) {
            userData.ppschool = store.state.selectedSchoolRef

            // fb.db.doc(store.state.selectedSchoolRef).get().then((doc) => {
            //   let school = doc.data()
            //   school.id = doc.id
            //   school.ref = doc.ref
            //   userData.school = school
            // })


            var ddoc = await fb.db.doc(store.state.selectedSchoolRef).get();
            let school = ddoc.data()
            if (school) {
              school.id = ddoc.id
              school.ref = ddoc.ref
              userData.school = school
            }
          } else {
            userData.ppschool = null
          }
          fb.db.collection("schools").orderBy("name", "asc").onSnapshot((schools) => {
            store.state.availableSchools = []
            schools.forEach((doc) => {
              let school = doc.data()
              school.id = doc.id
              school.ref = doc.ref
              store.state.availableSchools.push(school)
            })
          })
        }
        store.set("userData", userData);
      }
    }
  } else {
    //store.dispatch('clearData')
  }
  // if (user) {
  //   store.commit('setCurrentUser', user)
  //   store.dispatch('fetchUserProfile')

  // } else {
  //   store.dispatch('clearData')
  // }
  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
    mixins: [myfunction],
    created() {

    }
  }).$mount('#app')
})